import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import copyToClipboard from 'copy-to-clipboard';

import { LISTING_STATUS_ACTIVE } from 'common/listingConstants';
import { TOUR_SHOWING_STATUS_FAILED } from 'common/tourConstants';

class SrTourCopyAllMlsNumbersHeader extends Component {
  static propTypes = {
    listings: PropTypes.array.isRequired,
    showings: PropTypes.array.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      showClickedTooltip: false,
    };
    this._unmounting = false;
  }

  componentWillUnmount() {
    this._unmounting = true;
  }

  _onCopyAllMlsNumbersClick = (e) => {
    const { listings, showings } = this.props;
    e.preventDefault();
    e.stopPropagation();

    const mlsNumbers = listings
      .filter(({ id }) => {
        const showing = showings.find(({ listingId }) => listingId === id);
        return showing.status !== TOUR_SHOWING_STATUS_FAILED;
      })
      .filter(({ mlsStatus }) => mlsStatus === LISTING_STATUS_ACTIVE)
      .map((listing) => listing.mlsNumber)
      .join(' ');

    copyToClipboard(mlsNumbers);

    this.setState({
      showClickedTooltip: true,
    });
    setTimeout(() => {
      if (!this._unmounting) {
        this.setState({
          showClickedTooltip: false,
        });
      }
    }, 2000);
  };

  render() {
    const { showClickedTooltip } = this.state;

    return (
      <span onClick={this._onCopyAllMlsNumbersClick} className="copyAllMlsNumbers">
        <span className="secondaryAction">
          mls
          <span
            className={classnames(
              'copiedMessage',
              'mlsCopyAllMessage',
              showClickedTooltip && 'clicked',
            )}
          >
            Copied!
          </span>
        </span>
      </span>
    );
  }
}

SrTourCopyAllMlsNumbersHeader.displayName = 'SrTourCopyAllMlsNumbersHeader';

export default SrTourCopyAllMlsNumbersHeader;
